(function () {
  if (window.PearlpineCart) return;

  const cartRoot = (window.routes && window.routes.cart_url) || '/cart';
  let toastTimer = null;

  function showToast(message, linkText) {
    let toast = document.querySelector('.pp-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'pp-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '';
    const text = document.createElement('span');
    text.textContent = message;
    toast.appendChild(text);
    if (linkText) {
      const link = document.createElement('a');
      link.href = cartRoot;
      link.textContent = linkText;
      toast.appendChild(link);
    }
    window.requestAnimationFrame(() => toast.classList.add('is-visible'));
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 3500);
  }

  function addToCart(items) {
    return fetch(cartRoot + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then((response) =>
      response.json().then((data) => {
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        // A separate event name so Horizon's own cart:update listeners never see an unfamiliar payload.
        document.dispatchEvent(new CustomEvent('pp:cart-updated', { detail: data }));
        return data;
      })
    );
  }

  window.PearlpineCart = { add: addToCart, toast: showToast };

  // Card with an option dropdown and an Add to cart button
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pp-picker-add]');
    if (!button) return;
    event.preventDefault();
    const picker = button.closest('[data-pp-picker]');
    const select = picker && picker.querySelector('[data-pp-picker-select]');
    const id = parseInt(select ? select.value : button.getAttribute('data-pp-picker-add'), 10);
    if (!id) return;

    const label = button.textContent;
    button.classList.add('is-loading');
    addToCart([{ id: id, quantity: 1 }])
      .then(() => {
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        button.textContent = 'Added';
        showToast('Added to your cart.', 'View cart');
        window.setTimeout(() => {
          button.classList.remove('is-added');
          button.textContent = label;
        }, 1800);
      })
      .catch((error) => {
        button.classList.remove('is-loading');
        showToast(error.message);
      });
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pp-quick-add]');
    if (!button) return;
    event.preventDefault();
    const id = parseInt(button.getAttribute('data-pp-quick-add'), 10);
    if (!id) return;

    button.classList.add('is-loading');
    addToCart([{ id: id, quantity: 1 }])
      .then(() => {
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        showToast('Added to your cart.', 'View cart');
        window.setTimeout(() => button.classList.remove('is-added'), 1800);
      })
      .catch((error) => {
        button.classList.remove('is-loading');
        showToast(error.message);
      });
  });
})();
